export default __webpack_public_path__ + "static/media/insert-image.a996c5d0.svg";